var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('select-bar',{staticClass:"p-p-3 p-d-flex p-jc-between",on:{"updateReportName":_vm.updateReportName}}),_c('admin-list',{staticClass:"p-p-3",attrs:{"selectedReportName":_vm.selectedReportName}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }